import { getUrlVars } from './url-vars';

import { environment } from '../environments/environment';
import { GaClient } from './ga';
import { SetCartSource } from './idonatelib';
import { loadSiftLibrary } from './sift';
import { loadPendo } from './pendo';

function generateUUID() {
  let d = new Date().getTime();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

let loaded = false;

function loadPendoIfEnabled(embedInstance: any) {
  if (embedInstance.organization.features.includes('embed_analytics')) {
    loadPendo(embedInstance.organization_id);
  }
}

export function InitIframeEmbed(callback) {
  const urlVars = getUrlVars();
  const embedID = urlVars['embed_id'];
  const paypalVals = {
    donation: urlVars['donation'],
    token: urlVars['token'],
    payerId: urlVars['PayerID']
  };
  window.addEventListener('message', evt => {
    let evtData;
    if (!loaded) {
      try {
        evtData = JSON.parse(evt.data);
      } catch (error) {
        return;
      }
      if (evtData.embedData) {
        loaded = true;
        const data = evtData.embedData;
        data.embed_instance.session_id = generateUUID();

        SetCartSource(evt.source, data.embed_instance);
        GaClient.trackSession(data.embed_instance);
        loadSiftLibrary(data.embed_instance.session_id);
        loadPendoIfEnabled(data.embed_instance);

        callback({ ...data, ...paypalVals });
      }
    }
  });
  if (window.parent) {
    window.parent.postMessage(JSON.stringify({ embed_id: embedID }), '*');
  }
}

export function InitFramelessEmbed(callback) {
  const urlVars = getUrlVars();
  const embedID = urlVars['embed-id'];
  const paypalVals = {
    donation: urlVars['donation'],
    token: urlVars['token'],
    payerId: urlVars['PayerID']
  };
  if (embedID) {
    fetch(
      `${environment.rootAPI.replace(/^https?:/, '')}/embed/fetch/${embedID}`
    ).then(response => {
      response
        .json()
        .then(data => {
          data.embed_instance.session_id = generateUUID();
          GaClient.trackSession(data.embed_instance);
          loadSiftLibrary(data.embed_instance.session_id);
          loadPendoIfEnabled(data.embed_instance);

          return { ...data, ...paypalVals };
        })
        .then(callback);
    });
  } else {
    fetch('assets/embed-config.json').then(response => {
      response
        .json()
        .then(data => {
          data.embed_instance.session_id = generateUUID();
          GaClient.trackSession(data.embed_instance);
          loadSiftLibrary(data.embed_instance.session_id);
          loadPendoIfEnabled(data.embed_instance);

          return { ...data, ...paypalVals };
        })
        .then(callback);
    });
  }
}
